<template>
  <div class="page news">
    <page-banner
      title="新闻资讯"
      eyebrow="NEWS & NOTICE"
      subtitle="平台动态、演出公告、线路信息与出行提示"
    />
    <div class="page-body page-body--narrow" v-loading="loading">
      <div v-if="articles.length" class="news-list">
        <article
          v-for="item in articles"
          :key="item.id"
          class="news-card"
          @click="goDetail(item.id)"
        >
          <div
            v-if="item.coverImage"
            class="news-card__cover"
            :style="{ backgroundImage: 'url(' + resolveImage(item.coverImage) + ')' }"
          />
          <div class="news-card__body">
            <div class="news-card__head">
              <el-tag v-if="item.tag" size="mini" type="danger" effect="plain">{{ item.tag }}</el-tag>
              <span class="news-card__date">{{ formatDate(item.publishTime) }}</span>
            </div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.summary }}</p>
            <span class="news-card__more">阅读全文 →</span>
          </div>
        </article>
      </div>
      <div v-else-if="!loading" class="page-empty">
        <i class="el-icon-document" />
        <p>暂无资讯</p>
      </div>
      <div v-if="total > query.pageSize" class="pagination-wrap">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="query.pageSize"
          :current-page.sync="query.pageNum"
          @current-change="loadNews"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner.vue';
import { listNews } from '@/api/news';
import { resolveImageUrl } from '@/utils/image';
import { formatDate } from '@/utils/format';

export default {
  name: 'News',
  components: { PageBanner },
  data() {
    return {
      loading: false,
      articles: [],
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 10
      }
    };
  },
  created() {
    this.loadNews();
  },
  methods: {
    formatDate,
    resolveImage(src) {
      return resolveImageUrl(src);
    },
    loadNews() {
      this.loading = true;
      listNews(this.query)
        .then(res => {
          this.articles = res.rows || [];
          this.total = res.total || 0;
        })
        .catch(() => {
          this.articles = [];
          this.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goDetail(id) {
      this.$router.push('/news/' + id);
    }
  }
};
</script>

<style scoped>
.news-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.news-card {
  display: flex;
  gap: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #ebeef5;
  cursor: pointer;
  transition: box-shadow 0.2s, transform 0.2s;
}
.news-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}
.news-card__cover {
  width: 200px;
  min-height: 120px;
  flex-shrink: 0;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
}
.news-card__body {
  flex: 1;
  min-width: 0;
}
.news-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}
.news-card__date {
  font-size: 13px;
  color: #909399;
  white-space: nowrap;
}
.news-card h3 {
  margin: 0 0 8px;
  font-size: 17px;
  color: #303133;
  line-height: 1.5;
}
.news-card p {
  margin: 0 0 8px;
  font-size: 14px;
  color: #606266;
  line-height: 1.7;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.news-card__more {
  font-size: 13px;
  color: #c41e3a;
}
.pagination-wrap {
  margin-top: 24px;
  text-align: center;
}
.page-empty i {
  font-size: 48px;
  display: block;
  margin-bottom: 12px;
  color: #dcdfe6;
}
@media (max-width: 768px) {
  .news-card {
    flex-direction: column;
    padding: 16px;
    gap: 12px;
  }
  .news-card__cover {
    width: 100%;
    height: 160px;
  }
  .news-card__head {
    flex-wrap: wrap;
  }
}
</style>
